module.exports = __webpack_public_path__ + "media/create_scheme.e0162655.mp4";